import { z } from 'zod';

import { PaginationSchema } from '../../pagination.js';

export const ListFiscalRuleCorridorPacksQuerySchema = z.looseObject({
  originStateCode: z.string().length(2).optional(),
  destinationStateCode: z.string().length(2).optional(),
  taxRegime: z.enum(['SIMPLES_NACIONAL', 'LUCRO_PRESUMIDO', 'LUCRO_REAL']).optional(),
  verticalScope: z.string().max(30).optional(),
});

export const FiscalRuleCorridorPackItemSchema = z.looseObject({
  code: z.string(),
  name: z.string(),
  originStateCode: z.string(),
  destinationStateCode: z.string(),
  taxRegime: z.string(),
  isIntraState: z.boolean(),
  verticalScope: z.string().nullable(),
  templateRuleCount: z.number().int().nonnegative(),
});

export const ListFiscalRuleCorridorPacksResponseSchema = z.looseObject({
  items: z.array(FiscalRuleCorridorPackItemSchema),
});

export const UpsertTenantEnabledFiscalCorridorsBodySchema = z.looseObject({
  corridorPackCodes: z.array(z.string().min(1).max(50)).min(1),
  disableCodes: z.array(z.string().min(1).max(50)).optional(),
});

export const TenantEnabledFiscalCorridorItemSchema = z.looseObject({
  id: z.uuid(),
  corridorPackCode: z.string(),
  displayName: z.string().nullable(),
  status: z.string(),
  originStateCode: z.string().nullable().optional(),
  destinationStateCode: z.string().nullable().optional(),
  taxRegime: z.string().nullable().optional(),
});

export const ListTenantEnabledFiscalCorridorsQuerySchema = PaginationSchema;

export const ListTenantEnabledFiscalCorridorsResponseSchema = z.looseObject({
  items: z.array(TenantEnabledFiscalCorridorItemSchema),
  pagination: z.looseObject({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export const UpsertTenantEnabledFiscalCorridorsResponseSchema =
  ListTenantEnabledFiscalCorridorsResponseSchema;

export const ProvisionPlaceRuleSetFromCorridorsBodySchema = z.looseObject({
  validFrom: z.iso.date().optional(),
  name: z.string().max(120).optional(),
});

export const ProvisionPlaceRuleSetFromCorridorsResponseSchema = z.looseObject({
  ruleSetId: z.uuid(),
  rulesCloned: z.number().int().nonnegative(),
  status: z.literal('DRAFT'),
  packCodes: z.array(z.string()),
});

export type ListFiscalRuleCorridorPacksQuery = z.infer<
  typeof ListFiscalRuleCorridorPacksQuerySchema
>;
export type UpsertTenantEnabledFiscalCorridorsBody = z.infer<
  typeof UpsertTenantEnabledFiscalCorridorsBodySchema
>;
export type ListTenantEnabledFiscalCorridorsQuery = z.infer<
  typeof ListTenantEnabledFiscalCorridorsQuerySchema
>;
export type ProvisionPlaceRuleSetFromCorridorsBody = z.infer<
  typeof ProvisionPlaceRuleSetFromCorridorsBodySchema
>;
